import React from 'react'

import { SidebarCategoriesList } from 'ui/Layout/Sidebar/SidebarCategoriesList'
import { useCategoriesListQuery } from 'features/categories/hooks'
import { Skeleton } from 'shadcdn/ui/skeleton'

type Props = {
  className?: string
  initialData?: ReturnType<typeof useCategoriesListQuery>['data']
}

export const Sidebar = React.memo((props: Props) => {
  const { initialData, className } = props

  const { data: categories = [], isLoading } = useCategoriesListQuery({ initialData, enabled: !initialData })

  return (
    <div className={className}>
      <div className="flex grow flex-col pl-6 h-full gap-2">
        <div className=" flex flex-col gap-y-1">
          {isLoading ? <CategoriesSkeleton /> : <SidebarCategoriesList categories={categories} />}
          <div className="h-2" />
        </div>
      </div>
    </div>
  )
})

const CategoriesSkeleton = () => (
  <>
    <div className="flex flex-col gap-5">
      {[...Array(5)].map((_, i) => (
        <Skeleton className="h-4 w-full bg-gray-100" key={i} />
      ))}
    </div>
  </>
)
